import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {IPdfWorkerTemplate, PDfTemplateAction} from '../../models/pdf-template';
import {NzImageService} from 'ng-zorro-antd/image';
import {Store} from '@ngxs/store';
import {firstValueFrom} from 'rxjs';
import {MessageAlertService} from '../../services/message-alert/message-alert.service';
import {Loader} from '../../models/loader/loader.redux';

@Component({
  selector: 'app-card-template',
  templateUrl: './card-template.component.html',
  styleUrls: ['./card-template.component.scss']
})
export class CardTemplateComponent implements OnInit {

  @Input() pdfTemplate: IPdfWorkerTemplate;
  @Input() selected: boolean;
  @Input() expertId: string;
  @Output() selectTpl: EventEmitter<string> = new EventEmitter<string>();

  currentDate = new Date();
  tooltipsScore = ['terrible', 'malo', 'normal', 'bueno', 'excelente'];
  constructor(
    private nzImageService: NzImageService,
    private store: Store,
    private messageAlertService: MessageAlertService
  ) {
  }

  ngOnInit(): void {
  }

  onPreview(): void {
    const images = this.pdfTemplate.media.map(img => {
      return {src: img.key};
    });
    this.nzImageService.preview(images, { nzZoom: 0.9, nzRotate: 0 });

  }

  async onSelect(): Promise<void> {
    try {
      await firstValueFrom(this.store.dispatch(new Loader(true, 'Estableciendo plantilla predeterminada')));
      this.selectTpl.emit(this.pdfTemplate._id);
      await firstValueFrom(this.store.dispatch(new PDfTemplateAction.SetDefault(this.expertId, this.pdfTemplate._id)));
      this.messageAlertService.createMessage('success', 'Plantilla establecida como predeterminada.');
    } catch (e) {
      console.log(e);
      this.messageAlertService.createMessage('error', 'No se ha podido establecer la plantilla como predeterminada.');
    } finally {
      await firstValueFrom(this.store.dispatch(new Loader(false)));
    }
  }
}
